<template>
    <div>
        <h2 class="">Program Completion Filters</h2>
        <div class="mt-4">
            <button class="bg-green-400 text-white py-2 px-5 rounded " @click="() => { this.courseState = true; this.count = false; this.form.course = ''}">
                Filter by Compulsory Courses
            </button>
            <button class="bg-blue-500 text-white py-2 px-5 rounded ml-3" @click="() => { this.courseState = false; this.count = false; this.form.course = ''}">
                Filter by Elective Courses
            </button>
            <button class="bg-green-500 text-white py-2 px-5 rounded ml-3" @click="count = true">
                Filter by compulsory and elective count
            </button>
            <button class="bg-blue-500 text-white py-2 px-5 rounded ml-3" @click="getAllCompleted">
                Filter all completed learner
            </button>
        </div>
        <div class="flex flex-wrap items-end mt-4" v-show="!count">
            <div class="w-6/12" v-show="courseState">
                <multiselect v-model="form.course" tag-placeholder="Add this as new tag" placeholder="Select a compulsory lesson" label="title" track-by="title" :options="compulsory"></multiselect>
            </div>
            <div class="w-6/12" v-show="!courseState">
                <multiselect v-model="form.course" tag-placeholder="Add this as new tag" placeholder="Select an elective lesson" label="title" track-by="title" :options="electives"></multiselect>
            </div>
            <button class="bg-white py-3 px-5 rounded h-12 w-32 ml-2" @click="completedUsers">
                Filter
            </button>
        </div>
        <div class="mt-4" v-show="count">
            <p class="italic">Note: If the value of compulsory count is 3 and value of elective count is 1, it means you want to see learners that has completed atleast 3 compulsory and 1 elective courses.  </p>
            <div class="flex flex-wrap items-end mt-2">
                <div class="mr-3 flex flex-col">
                    <!-- <label for="">Compulsory Count</label> -->
                    <select v-model="form.compulsory_count" name="" id="" placeholder="" class="py-3 px-4 w-64">
                        <option>select compulsory Count</option>
                        <option :value="n" v-for="n in 10" :key="n.id">{{ n }}</option>
                    </select>
                </div>
                <div class=" flex flex-col">
                    <!-- <label for="">Elective Count</label> -->
                    <select v-model="form.elective_count" name="" id="" placeholder="" class="py-3 px-4 w-64">
                        <option>select elective Count</option>
                        <option :value="n" v-for="n in 8" :key="n.id">{{ n }}</option>
                    </select>
                </div>
                <button class="bg-white py-3 px-5 rounded h-12 w-32 ml-2" @click="tracker">
                    Filter
                </button>
            </div>
        </div>

        <div class="inline-block min-w-full shadow rounded-lg my-4" v-show="statDefault">
            <div class="flex items-center justify-between bg-white">
                <p class="mx-3">Total Learners: {{ total }}</p>
                <download-csv
                    class="custom_support-color text-white py-3 px-6 rounded cursor-pointer"
                    name="lms.csv"
                    :data   = "jsonCsv">
                    Download as CSV
                    <!-- <img src="download_icon.png"> -->
                </download-csv>
                <!-- <button class="custom_support-color text-white py-3 px-6 rounded">Download as CSV</button> -->
            </div>
            <table class="min-w-full leading-normal">
                <thead>
                    <tr>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            S/N
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Name
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Email
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Phone Number
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user,index) in users.data" :key="user.learner_id">
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ index+1 }}</td>
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.first_name + ' '+ user.last_name}}</td>    
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.email }}</td>
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.phone_number }}</td>  
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        <router-link :to="'users/details/' + user.learner_id" tag="button" class="custom_support-color rounded text-white py-2 px-5">View</router-link>
                        </td>            
                    </tr>
        
                </tbody>
            </table>

            <!-- Pagination -->
            <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                <div class="flex-1 flex justify-between sm:hidden">
                    <a href="#" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
                    Previous
                    </a>
                    <a href="#" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
                    Next
                    </a>
                </div>
                <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                    <div>
                    <p class="text-sm text-gray-700">
                        Showing
                        <span class="font-medium">{{ from }}</span>
                        to
                        <span class="font-medium">{{ to }}</span>
                        of
                        <span class="font-medium">{{ total }}</span>
                        results
                    </p>
                    </div>
                    <div>
                    <nav class="relative z-0 inline-flex shadow-sm -space-x-px" aria-label="Pagination">
                        <a href="#" :disabled="!prev_page" @click.prevent="stat(current_page-1)" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                            <span class="sr-only">Previous</span>
                            
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                            </svg>
                        </a>
                        <a href="#" :disabled="!next_page" @click.prevent="stat(current_page+1)" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                            <span class="sr-only">Next</span>
                            
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                            </svg>
                        </a>
                    </nav>
                    </div>
                </div>
            </div> 
        </div>

        <!-- Completion Tracker -->
        <div class="inline-block min-w-full shadow rounded-lg my-4" v-show="counter">
            <div class="flex items-center justify-between bg-white">
                <p class="mx-3">Total Learners: {{ total }}</p>
                <download-csv
                    class="custom_support-color text-white py-3 px-6 rounded cursor-pointer"
                    name="lms.csv"
                    :data   = "jsonCsv">
                    Download as CSV
                    <!-- <img src="download_icon.png"> -->
                </download-csv>
                <!-- <button class="custom_support-color text-white py-3 px-6 rounded">Download as CSV</button> -->
            </div>
            <table class="min-w-full leading-normal">
                <thead>
                    <tr>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            S/N
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Name
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Email
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Phone Number
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user,index) in counter_users.data" :key="user.learner_id">
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ index+1 }}</td>
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.first_name + ' '+ user.last_name}}</td>    
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.email }}</td>
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.phone_number }}</td>  
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        <router-link :to="'users/details/' + user.learner_id" tag="button" class="custom_support-color rounded text-white py-2 px-5">View</router-link>
                        </td>            
                    </tr>
        
                </tbody>
            </table>

            <!-- Pagination -->
            <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                <div class="flex-1 flex justify-between sm:hidden">
                    <a href="#" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
                    Previous
                    </a>
                    <a href="#" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
                    Next
                    </a>
                </div>
                <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                    <div>
                    <p class="text-sm text-gray-700">
                        Showing
                        <span class="font-medium">{{ from }}</span>
                        to
                        <span class="font-medium">{{ to }}</span>
                        of
                        <span class="font-medium">{{ total }}</span>
                        results
                    </p>
                    </div>
                    <div>
                    <nav class="relative z-0 inline-flex shadow-sm -space-x-px" aria-label="Pagination">
                        <a href="#" :disabled="!prev_page" @click.prevent="tracker(current_page-1)" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                            <span class="sr-only">Previous</span>
                            
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                            </svg>
                        </a>
                        <a href="#" :disabled="!next_page" @click.prevent="tracker(current_page+1)" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                            <span class="sr-only">Next</span>
                            
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                            </svg>
                        </a>
                    </nav>
                    </div>
                </div>
            </div> 
        </div>

        <!-- Completed Learners-->
        <div class="inline-block min-w-full shadow rounded-lg my-4" v-show="completedLearner">
            <div class="flex items-center justify-between bg-white">
                <p class="mx-3">Total Learners: {{ total }}</p>
                <download-csv
                    class="custom_support-color text-white py-3 px-6 rounded cursor-pointer"
                    name="lms.csv"
                    :data   = "jsonCsv">
                    Download as CSV
                    <!-- <img src="download_icon.png"> -->
                </download-csv>
                <!-- <button class="custom_support-color text-white py-3 px-6 rounded">Download as CSV</button> -->
            </div>
            <table class="min-w-full leading-normal">
                <thead>
                    <tr>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            S/N
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Name
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Email
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Phone Number
                        </th>
                        <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user,index) in completed_users.data" :key="user.id">
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ index+1 }}</td>
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.first_name + ' '+ user.last_name}}</td>    
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.email }}</td>
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">{{ user.phone_number }}</td>  
                        <td class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        <router-link :to="'users/details/' + user.user_id" tag="button" class="custom_support-color rounded text-white py-2 px-5">View</router-link>
                        </td>            
                    </tr>
        
                </tbody>
            </table>

            <!-- Pagination -->
            <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                <div class="flex-1 flex justify-between sm:hidden">
                    <a href="#" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
                    Previous
                    </a>
                    <a href="#" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
                    Next
                    </a>
                </div>
                <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                    <div>
                    <p class="text-sm text-gray-700">
                        Showing
                        <span class="font-medium">{{ from }}</span>
                        to
                        <span class="font-medium">{{ to }}</span>
                        of
                        <span class="font-medium">{{ total }}</span>
                        results
                    </p>
                    </div>
                    <div>
                    <nav class="relative z-0 inline-flex shadow-sm -space-x-px" aria-label="Pagination">
                        <a href="#" :disabled="!prev_page" @click.prevent="getAllCompleted(current_page-1)" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                            <span class="sr-only">Previous</span>
                            
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                            </svg>
                        </a>
                        <a href="#" :disabled="!next_page" @click.prevent="getAllCompleted(current_page+1)" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                            <span class="sr-only">Next</span>
                            
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                            </svg>
                        </a>
                    </nav>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {
    mapMutations,
    mapActions
} from "vuex";
export default {
    name:'tenant-users-completion',
    components: {
        Multiselect
    },
    data(){
        return {
            courseState:true,
            compulsory:[],
            completedLearner:false,
            electives:[],
            users:{},
            counter_users:{},
            completed_users:{},
            statDefault:true,
            count:false,
            counter:false,
            current_page:'',
            per_page:'',
            from:'',
            to:'',
            total:'',
            last_page:null,
            prev_page:null,
            next_page:null,
            jsonCsv:[],
            form:{
                course:'',
                compulsory_count:'',
                elective_count:''
            },
            options: [
                { name: 'Vue.js', code: 'vu' },
                { name: 'Javascript', code: 'js' },
                { name: 'Open Source', code: 'os' }
            ]
        };
    },
    async mounted(){
        this.getLessons();
        this.stat();
    },
    methods:{
        ...mapActions(["learnerLessons","lessonStat","completionTracker","fetchAllCompletedLearner"]),
        ...mapMutations(["updateLoader"]),
        async tracker(){
            this.updateLoader(true);
            try {

                const res = await this.completionTracker({
                    page:1,
                    compulsory_count: this.form.compulsory_count,
                    elective_count: this.form.elective_count,
                });
                if(res.status === 200){
                    this.counter = true;
                    this.completedLearner = false;
                    this.statDefault = false,
                    this.makePagination(res.data.data);
                    this.counter_users = res.data.data;
                    let data = res.data.data.map((e)=> {
                        return {
                            name: e.first_name + ' ' + e.last_name,
                            email: e.email,
                            phone_number: e.phone_number.toString()
                        };
                    })
                    // console.log(data)
                    this.jsonCsv = data;
                }
                console.log(res.data.data)
                this.updateLoader(false);
            }catch (e){
                // console.log(e)
                this.updateLoader(false);
            }
        },
        async getAllCompleted(page = 1) {
            this.updateLoader(true);
            try {
                const data = {
                    page
                };
                const res = await this.fetchAllCompletedLearner(data);
                if(res.status === 200)
                {
                    this.makePagination(res.data.data);
                    this.completed_users = res.data.data;
                    this.completedLearner = true;
                    this.statDefault = false;
                    this.counter = false;
                    // console.log(res.data)
                }
                this.updateLoader(false);
            } catch(err) {
                 this.updateLoader(false);
            }
        },
        async completedUsers(page = 1){
            this.updateLoader(true);
            try {
                
                let course = this.form.course.id;
                let data = {
                    course,
                    page
                };
                const res = await this.lessonStat(data);
                if(res.status === 200)
                {
                    // console.log(res)
                    this.counter = false;
                    this.makePagination(res.data);
                    this.users = res.data;
                    let data = res.data.data.map((e)=> {
                        return {
                            name: e.first_name + ' ' + e.last_name,
                            email: e.email,
                            phone_number: e.phone_number.toString()
                        };
                    })
                    // console.log(data)
                    this.jsonCsv = data;
                    this.updateLoader(false);
                }
            } catch (e) {

            }
        },
        async getLessons(){
            this.updateLoader(true);
            try {
                const res = await this.learnerLessons();
                this.compulsory = res.data.compulsory;
                // this.form.compulsory.push(res.data.compulsory[0]);
                this.electives = res.data.elective;
                // this.form.elective.push(res.data.elective[0]);
                // console.log(res);
                this.updateLoader(false);
            } catch(e){
                this.updateLoader(false);
            }
        },
        async stat(page = 1){
            this.updateLoader(true);
            try {
                let data = {
                    course:'',
                    page
                };
                const res = await this.lessonStat(data);
                if(res.status === 200)
                {
                    // console.log(res)
                    this.makePagination(res.data);
                    this.users = res.data;
                    // this.statDefault = true;
                    let data = res.data.data.map((e)=> {
                        return {
                            name: e.first_name + ' ' + e.last_name,
                            email: e.email,
                            phone_number: e.phone_number.includes('+234') ? e.phone_number.split('+234')[1] : e.phone_number
                        };
                    })
                    // console.log(data)
                    this.jsonCsv = data;
                    this.updateLoader(false);
                }
            } catch(e){
                this.updateLoader(false);
            }
        },
        makePagination(data) {
            this.current_page = data.current_page;
            this.last_page = data.last_page;
            this.per_page = data.per_page;
            this.from = data.from;
            this.to = data.to;
            this.total = data.total;
            this.prev_page = data.prev_page_url;
            this.next_page = data.next_page_url;
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag{
    background-color:#2E3A6E;
}
.multiselect__option{
    font-size:12px;
}
.multiselect__option--highlight, .multiselect__option--highlight:after{
    background-color:#2E3A6E;
}
.multiselect__tag-icon:after{
    color:#fff;
}
.custom_support-color{
    background-color: #2E3A6E;
}
</style>